import React from 'react'
import PropTypes from 'prop-types';
import { Box, makeStyles, Typography } from '@material-ui/core';
import statusCnae from '../functions/StatusCnae';
import CheckIcon from '../atoms/icons/CheckIcon';
import AmbiguousIcon from '../atoms/icons/AmbiguousIcon';
import CloseRoundedIcon from '../atoms/icons/CloseRoundedIcon';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    boxShadow: '0px 0px 1px rgba(9, 30, 66, 0.31)',
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
  },
  description: {
    color: '#42526E',
    marginLeft: '16px',
    fontWeight: 'normal'
  }
}))

const typeFlag = {
  Permitido: {
    icon: <CheckIcon />,
    text: 'Permitido no simples nacional',
  },
  Impeditivo: {
    icon: <CloseRoundedIcon />,
    text: 'Impeditivo no Simples Nacional'
  },
  Ambiguo: {
    icon: <AmbiguousIcon />,
    text: 'Atividade ambígua que PODEM e NÃO PODE, ao mesmo tempo, serem Simples Nacional'
  }
}

export default function Flag({ type }) {
  const classes = useStyles();

  const result = statusCnae(type);
  const { icon, text } = typeFlag[result];

  return (
    <Box className={classes.container}>
      {icon}
      <Typography variant={'subtitle2'} component="p" className={classes.description}>
        {text}
      </Typography>
    </Box>
  )
}

Flag.propTypes = {
  type: PropTypes.string.isRequired
}
